<script lang="ts">
  import { paramsService, procedencesService } from '../services';
  import type { Procedence } from '../Model/Procedence';
  import type { Param } from '../Model/Param';

  export let procedenceSelectId: string;

  let procedences: Procedence[];
  let procedencesShow: Procedence[] = [];
  let params: Param[];


  load();

  async function load() {

    params = await paramsService.findByType('modules');
    procedences = await procedencesService.find();

    const paramSelect = params.find(p => p.name == 'Registro General de Entrada y Salida');

    if (!paramSelect) {
      return;
    }

    for (const procedence of procedences) {
      if (procedence.moduleId == paramSelect.id) {
        procedencesShow.push(procedence)
      }
    }

    procedencesShow.sort((a, b) => {
      return a.name < b.name ? -1 : 1;
    });

    procedencesShow = procedencesShow;
  }

</script>

{#if procedencesShow}
  <div class="input-group">
    <select class="form-select" bind:value={procedenceSelectId}>
      {#each procedencesShow as procedence}
        <option value={procedence.id}>{procedence.name}</option>
      {/each}
    </select>
  </div>
{/if}

<style>
</style>
